// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"e76a4793","895":"87053853"}[chunkId] + ".chunk.js";
};